import React, { useEffect, useState } from 'react'
import Journey from '../../journeys/journey/Journey'
import { TemplateProps } from '../../journeys/journey/Interfaces';
import ackJourneyJson from '../../journeys/journey/bol-ack-journey.json';
import Header from '../../organisms/Header/Header';
import './BolLayout.scss'
import { getJourneyDetails, getAckJourneyPath } from "../../graphql/getJourney.query";
import { Spinner } from 'ams-ui-reactkit';
import { navigate, useLocation } from '@reach/router';
import { StoreContext } from '../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import { actionTypeConstants } from '../../utils';
import { getBolSignatures } from '../../graphql/getBolSignature.query';
import { getCustomerId, IsLoggedIn } from '../../utils/Utils';
import { getItemFromSessionStorage } from '../../utils/storageUtils';
import SnackMessage from '../../atoms/SnackMessage';
import { checkForError } from '../../graphql/checkForError.query';


const BolLayout: React.FC<TemplateProps> = (props: any) => {

    const location = useLocation();
    const jourenyInfo: any = useContextSelector(StoreContext, store => store?.appState?.jourenyInfo);
    const uiState: any = useContextSelector(StoreContext, store => store?.appState?.ui);
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const signaturesState: any = useContextSelector(StoreContext, store => store?.appState?.signatures);
    const bolType: any = getItemFromSessionStorage("bolType");

    const [loader, setloader] = useState(false)
    const [journeytemplate, setjourneytemplate] = useState<any>()
    const errorPageFlag = process.env.REACT_APP_REDIRECT_TO_ERROR_PAGE ? process.env.REACT_APP_REDIRECT_TO_ERROR_PAGE === "true" : true
    const downloadPageFlag = process.env.REACT_APP_REDIRECT_TO_DOWNLOAD_PDF_PAGE ? process.env.REACT_APP_REDIRECT_TO_DOWNLOAD_PDF_PAGE === "true" : true

    const checkForErrors = () => {
        const params = {
            "customerId": getCustomerId()
        }
        checkForError(params).then((dataResults: any) => {
            if (dataResults?.isError) {
                navigate("/error")
            }
        }).catch((error) => {
            console.error("checkForErrors:", error);
        })
    }

    useEffect(() => {
        IsLoggedIn().then((result: any) => {
            if (result) {
                if (errorPageFlag) {
                    checkForErrors();
                }
                getTemplate();
                if (!signaturesState?.length && getCustomerId()) {
                    getSignatures();
                }
            } else {
                navigate("/login")
            }
        }).catch(() => {
            navigate("/login")
        });
        return () => {
            setjourneytemplate({});
        };
    }, []);

    useEffect(() => {
        if (downloadPageFlag) {
            getPdfPath();
        }
    }, [location.pathname]);

    useEffect(() => {
        //ignoring bol-pdf page out of no. of pages to show full progress bar on last page.
        const pageCount = journeytemplate && Object.keys(journeytemplate?.pages)?.length - 1;

        dispatch({
            type: actionTypeConstants.UPDATE_PAGE_COUNT,
            payload: {
                noOfPagesInJourney: pageCount || 0
            }
        });

    }, [journeytemplate]);

    /*
    * bolType 1 is acknowledgment journey
    * Otherwise BOL journey will start
    */
    const getTemplate = async () => {
        setloader(true)
        if (bolType === "1") {
            let ackJourney = await getAckJourneyPath({ customerId: getCustomerId() })
            if (ackJourney)
                setjourneytemplate(JSON.parse(ackJourney));
        }
        else {
            let journeyRes = await getJourneyDetails({ customerId: getCustomerId() });
            setjourneytemplate(JSON.parse(journeyRes));
        }
        setloader(false)
    }

    const getSignatures = () => {
        const params = {
            "customerId": getCustomerId()
        }
        getBolSignatures(params).then((dataResults: any) => {
            console.log("getBolSignatures:", dataResults);
            if (dataResults) {
                dispatch({
                    type: actionTypeConstants.STORE_SIGNATURES_API,
                    payload: dataResults
                })
            }
        }).catch((error) => {
            console.error("getBolSignatures:", error);
        })
    }

    const isBackNav = () => {

        if (uiState?.showBackLink === "hide") {
            return false;
        }
        if (uiState?.showBackLink === "show") {
            return true;
        }

        //historyIndex is 0 index variable here so noOfPagesInJourney -1
        if (uiState?.historyIndex && uiState?.historyIndex < (jourenyInfo?.noOfPagesInJourney - 1)) {
            return true;
        }
        return false;
    };

    const showProgress = () => {
        const pages = jourenyInfo?.noOfPagesInJourney || 0;
        const idx: any = uiState?.historyIndex || 0;

        return (idx / (pages - 1)) * 100;
    }


    const downloadPdf = (data: any) => {
        if (data.length > 0 && bolType === "0") {
            if (getItemFromSessionStorage('isJourneyCompleted') === null || getItemFromSessionStorage('isJourneyCompleted') === "1") {

                navigate("/bol/pdf-download");
            }
        }

        else if (data.length > 0 && bolType === "1") {
            if (getItemFromSessionStorage('isJourneyCompleted') === null || getItemFromSessionStorage('isJourneyCompleted') === "1") {
                navigate("/ack/pdf-download");
            }
        }
    }
    const getPdfPath = () => {

        const endPoint = `${process.env.REACT_APP_BOL_PDF}/getPdfS3Url`;

        if (process.env.REACT_APP_BOL_PDF) {
            fetch(endPoint, {
                method: 'POST',
                headers: {
                    'x-api-key': `${process.env.REACT_APP_BOL_PDF_API_KEY}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "customerId": getCustomerId(),
                    "pdfType": bolType === "0" ? "BOL" : "ACK"
                })
            })
                .then(response => response.json())
                .then(data => {

                    dispatch({
                        'type': actionTypeConstants.BOL_DATA,
                        'payload': { "pdfPath": data }
                    });

                    /**
                     *  `isJourneyCompleted` is used when to redirect the user to pdf download page after the journey completed.
                     *  if `isJourneyCompleted` exist in the storage, 
                     *    then we have consider both isJourneyCompleted value and bol status. 
                     *    This is to avoid redirecting user to download page without reaching to last page of the app.
                     *  if `isJourneyCompleted` doesn't exist in the storage and if user is directly access the application url 
                     *    then we have to redirect to download page
                     **/
                    downloadPdf(data);

                });
        } else {
            console.warn("couldn't find REACT_APP_BOL_PDF env value");
        }


    }


    return (
        <div className='full-block'>
            {
                loader || !journeytemplate ?
                    <div className='flex-center h-100vh'>
                        <Spinner />
                    </div>
                    :
                    <>
                      <Header backNav={isBackNav()} progressValue={showProgress() || 0} logoSrc = {journeytemplate?.logo}/>
                      <div className="outlineContainer">
                        <SnackMessage />
                        <Journey goal={journeytemplate?.goal || {}} pages={journeytemplate?.pages || {}} />
                    </div>
                    </>
            }
        </div>
    )
}

export default BolLayout